/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListUnknownSkillActivationsResult,
  ListUnknownSkillActivationsResult$inboundSchema,
} from "../components/listunknownskillactivationsresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListUnknownSkillActivationsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListUnknownSkillActivationsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListUnknownSkillActivationsSecurity = {
  option1?: ListUnknownSkillActivationsSecurityOption1 | undefined;
  option2?: ListUnknownSkillActivationsSecurityOption2 | undefined;
};

export type ListUnknownSkillActivationsRequest = {
  /**
   * Cursor for the next page of unknown activations.
   */
  cursor?: string | undefined;
  /**
   * The number of unknown activations to return per page.
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

export type ListUnknownSkillActivationsResponse = {
  result: ListUnknownSkillActivationsResult;
};

/** @internal */
export type ListUnknownSkillActivationsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListUnknownSkillActivationsSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListUnknownSkillActivationsSecurityOption1$Outbound,
    ListUnknownSkillActivationsSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listUnknownSkillActivationsSecurityOption1ToJSON(
  listUnknownSkillActivationsSecurityOption1:
    ListUnknownSkillActivationsSecurityOption1,
): string {
  return JSON.stringify(
    ListUnknownSkillActivationsSecurityOption1$outboundSchema.parse(
      listUnknownSkillActivationsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListUnknownSkillActivationsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListUnknownSkillActivationsSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListUnknownSkillActivationsSecurityOption2$Outbound,
    ListUnknownSkillActivationsSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listUnknownSkillActivationsSecurityOption2ToJSON(
  listUnknownSkillActivationsSecurityOption2:
    ListUnknownSkillActivationsSecurityOption2,
): string {
  return JSON.stringify(
    ListUnknownSkillActivationsSecurityOption2$outboundSchema.parse(
      listUnknownSkillActivationsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListUnknownSkillActivationsSecurity$Outbound = {
  Option1?: ListUnknownSkillActivationsSecurityOption1$Outbound | undefined;
  Option2?: ListUnknownSkillActivationsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListUnknownSkillActivationsSecurity$outboundSchema: z.ZodMiniType<
  ListUnknownSkillActivationsSecurity$Outbound,
  ListUnknownSkillActivationsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListUnknownSkillActivationsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListUnknownSkillActivationsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listUnknownSkillActivationsSecurityToJSON(
  listUnknownSkillActivationsSecurity: ListUnknownSkillActivationsSecurity,
): string {
  return JSON.stringify(
    ListUnknownSkillActivationsSecurity$outboundSchema.parse(
      listUnknownSkillActivationsSecurity,
    ),
  );
}

/** @internal */
export type ListUnknownSkillActivationsRequest$Outbound = {
  cursor?: string | undefined;
  limit: number;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListUnknownSkillActivationsRequest$outboundSchema: z.ZodMiniType<
  ListUnknownSkillActivationsRequest$Outbound,
  ListUnknownSkillActivationsRequest
> = z.pipe(
  z.object({
    cursor: z.optional(z.string()),
    limit: z._default(z.int(), 50),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listUnknownSkillActivationsRequestToJSON(
  listUnknownSkillActivationsRequest: ListUnknownSkillActivationsRequest,
): string {
  return JSON.stringify(
    ListUnknownSkillActivationsRequest$outboundSchema.parse(
      listUnknownSkillActivationsRequest,
    ),
  );
}

/** @internal */
export const ListUnknownSkillActivationsResponse$inboundSchema: z.ZodMiniType<
  ListUnknownSkillActivationsResponse,
  unknown
> = z.pipe(
  z.object({
    Result: ListUnknownSkillActivationsResult$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Result": "result",
    });
  }),
);

export function listUnknownSkillActivationsResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListUnknownSkillActivationsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ListUnknownSkillActivationsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListUnknownSkillActivationsResponse' from JSON`,
  );
}
